import { render } from "./StylesManager.vue?vue&type=template&id=3b94e165"
import script from "./StylesManager.vue?vue&type=script&lang=js"
export * from "./StylesManager.vue?vue&type=script&lang=js"

import "./StylesManager.vue?vue&type=style&index=0&id=3b94e165&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__